// src/components/PopupCarousel.jsx
import React from "react";
import Slider from "react-slick";

// Default settings (can be overridden by props if needed)
const defaultSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000, // Slightly longer pause
  arrows: false,
  pauseOnHover: true,
  // Default dotsClass, can be overridden via props
  dotsClass: "slick-dots custom-dots-gold",
};

export default function PopupCarousel({
  slides = [], // Default to empty array
  onSlideChange = () => {}, // Default to no-op function
  settings: customSettings = {}, // Allow overriding settings via props
  dotStyle = "custom-dots-gold" // Allow passing custom dot class
}) {
  // Merge default and custom settings
  const settings = {
    ...defaultSettings,
    ...customSettings,
    dotsClass: `slick-dots ${dotStyle}`, // Apply the dotStyle class
    // **Crucial:** Use afterChange to notify parent of slide index change
    afterChange: (currentSlideIndex) => {
      onSlideChange(currentSlideIndex);
    },
  };

  // Handle empty slides gracefully
  if (!slides || slides.length === 0) {
    return <div className="w-full aspect-square bg-gray-200 rounded-lg flex items-center justify-center text-gray-500">No images</div>; // Placeholder for no slides
  }

  return (
    <Slider {...settings} className="w-full h-full">
      {slides.map((slide, index) => (
        // Use slide.id if available and unique, otherwise fallback to index
        <div key={slide.id || index} className="w-full aspect-square px-1"> {/* Added slight padding for visual separation */}
          <img
            src={slide.image}
            // Use heading (mapped from title) or catchphrase as alt text
            alt={slide.heading || slide.catchphrase || `Popup Slide ${index + 1}`}
            className="w-full h-full object-cover rounded-lg shadow-sm" // Added shadow
            onError={(e) => { e.target.src = 'placeholder-image-url.jpg'; e.target.alt = 'Image loading failed'; }} // Basic image error handling
          />
        </div>
      ))}
    </Slider>
  );
}